import React, { Component } from 'react'

class SectionTitleOne extends Component {
    render() {
        var { BigTitle } = this.props;
        return (
            <div className="row">
                <div className="col-sm-12 text-center">
                    <div className="section-title-one">
                        <h2>{BigTitle}</h2>
                    </div>
                </div>
            </div>
        )
    }
}

export default SectionTitleOne
